/* global viabovag */
import { closest, getCookie, getPageDataKeyValue, setCookie } from 'js/tools';
import {
    getMobilityTypeFromVehicleData,
    getMobilityTypeFromVehicleNode,
    getProductDataFromVehicleData,
    getProductDataFromVehicleNode,
    registerEcommerceEvent
} from 'js/ecommerce';
import registerEvent from 'js/web-event-api-wrapper';

const ATTR_VEHICLE_ID = 'data-vehicle-id';

const CLASS_ACTIVE = 'favorite--active';

const COOKIE_NAME = 'ViaBovag-Favorites';
const COOKIE_VALUE_SEPARATOR = '|';
const COOKIE_DAYS = 365;
const FAVORITES_COUNT_MAX = 50;
const FAVORITES_COUNT_MAX_ERROR = `Je hebt het maximum van ${FAVORITES_COUNT_MAX} favorieten bereikt`;

export default class Favorite {
    constructor(node) {
        this.node = node;
        this.node.addEventListener('click', e => this.handleClick(e));

        this.pageType = getPageDataKeyValue('pageType');
    }

    handleClick(e) {
        e.preventDefault();

        this.toggleFavorite(!this.isActive());
    }

    toggleFavorite(toggle) {
        if (toggle) {
            const favoritesCount = this.getFavoritesCount();

            if (favoritesCount >= FAVORITES_COUNT_MAX) {
                this.showError();

                return;
            }
        }

        this.toggleHeart(toggle);

        const vehicleId = this.getVehicleId(this.node);

        toggle ? this.add(vehicleId, this.node) : this.remove(vehicleId, this.node);
    }

    getFavoritesCount() {
        const cookie = getCookie(COOKIE_NAME);

        if (!cookie || !cookie.value) {
            return 0;
        }

        return cookie.value.split(COOKIE_VALUE_SEPARATOR).length;
    }

    showError() {
        viabovag.toast.setType('error');
        viabovag.toast.setContent(FAVORITES_COUNT_MAX_ERROR);
        viabovag.toast.toggle();
    }

    isActive() {
        return this.node.classList.contains(CLASS_ACTIVE);
    }

    toggleHeart(toggle) {
        this.node.classList.toggle(CLASS_ACTIVE, toggle);
    }

    getVehicleId(node) {
        return node.getAttribute(ATTR_VEHICLE_ID);
    }

    add(vehicleId, node) {
        const vehicleIds = [];
        const cookie = getCookie(COOKIE_NAME);

        if (cookie) {
            const { value: cookieValue } = cookie;

            if (cookieValue.length) {
                vehicleIds.push(...cookieValue.split(COOKIE_VALUE_SEPARATOR));
            }
        }

        if (!vehicleIds.includes(vehicleId)) {
            vehicleIds.push(vehicleId);

            registerEvent({
                eventName: 'favorite-added',
                payload: {
                    vehicleId
                }
            });

            registerEcommerceEvent('addToCart', {
                currencyCode: 'EUR',
                add: this.getEcommerceEventData(node)
            });
        }

        const updatedCookieValue = vehicleIds.join(COOKIE_VALUE_SEPARATOR);

        this.updateFavoritesCookie(updatedCookieValue);
    }

    remove(vehicleId, node) {
        const cookie = getCookie(COOKIE_NAME);

        if (!cookie) {
            return;
        }

        const { value: cookieValue } = cookie;

        const vehicleIds = cookieValue
            .split(COOKIE_VALUE_SEPARATOR)
            .filter(cookieVehicleId => cookieVehicleId !== vehicleId);

        const updatedCookieValue = vehicleIds.join(COOKIE_VALUE_SEPARATOR);

        this.updateFavoritesCookie(updatedCookieValue);

        registerEcommerceEvent('removeFromCart', {
            currencyCode: 'EUR',
            remove: this.getEcommerceEventData(node)
        });
    }

    updateFavoritesCookie(value) {
        setCookie({
            name: COOKIE_NAME,
            value,
            days: COOKIE_DAYS
        });

        const count = value.split('|').filter(e => e.length).length;

        const event = new CustomEvent('favoritesUpdated', {
            bubbles: true,
            detail: {
                count
            }
        });

        window.dispatchEvent(event);
    }

    getEcommerceEventData(node) {
        const eventData = {
            actionField: {},
            products: []
        };

        if (this.pageType === 'vehicle-details') {
            eventData.actionField.list = getMobilityTypeFromVehicleData();
            eventData.products.push({
                ...getProductDataFromVehicleData(),
                quantity: 1
            });
        } else {
            eventData.actionField.list = getMobilityTypeFromVehicleNode(closest(node, 'search-result'));
            eventData.products.push({
                ...getProductDataFromVehicleNode(closest(node, 'search-result')),
                quantity: 1
            });
        }

        return eventData;
    }
}
